import { render, staticRenderFns } from "./Kontaktperson.vue?vue&type=template&id=5016d380"
import script from "./Kontaktperson.vue?vue&type=script&lang=js"
export * from "./Kontaktperson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports